import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {CheckoutPaymentBaseComponent} from "../checkout-payment-base/checkout-payment-base.component";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {TranslateService} from "@ngx-translate/core";
import {StoreOrderService} from "../../../../stores/store-order/store-order.service";
import {PaymentService} from "../../../payments/payment.service";
import {LocationService} from "../../../location.service";
import {WhitelabelService} from "../../../../shared/whitelabel.service";
import {WINDOW} from "../../../window-providers";
import {PaymentsenseService} from "../../../payments/paymentsense.service";
import {LocalStorageService} from "../../../../local-storage.service";
import {environment} from "../../../../../environments/environment";
import {ClearIntegrationPayment} from "../../../payments/+state/payment.actions";
import {ErrorMessage} from "../../+state/stores.actions";
import {Event} from "../../../../stores/event";
import {ClientStore} from "../../../../stores/stores";
import { CheckoutPaymentFormsComponent } from '../checkout-payment-forms/checkout-payment-forms.component';

@Component({
  selector: 'app-checkout-payment-order',
  templateUrl: './checkout-payment-order.component.html',
  styleUrl: './checkout-payment-order.component.scss'
})
export class CheckoutPaymentOrderComponent extends CheckoutPaymentBaseComponent implements OnInit {

  @Input() backToCurrentCat: string
  @Input() selectedStore: ClientStore;
  showPaymentPay: boolean = false;
  @ViewChild('checkoutPaymentFormsComponent') checkoutPaymentFormsComponent: CheckoutPaymentFormsComponent;

  constructor(protected route: ActivatedRoute,
              protected store: Store<any>,
              protected translate: TranslateService,
              protected storeOrderService: StoreOrderService,
              protected paymentService: PaymentService,
              protected locationService: LocationService,
              protected whitelabelService: WhitelabelService,
              @Inject(WINDOW) protected window: Window,
              protected paymentsenseService: PaymentsenseService,
              protected router: Router,
              protected storageService: LocalStorageService
  ) {
    super(route, store, translate, storeOrderService, paymentService, locationService, whitelabelService, window, paymentsenseService, router, storageService);
  }

  onInitiatePaymentFailure(evt: Event) {
    this.store.dispatch(new ClearIntegrationPayment(evt));
    this.store.dispatch(new ErrorMessage('public.payment.errorCouldNotConnect'));
  }

  redirectPaymentPay() {
    this.showPaymentPay = true;
  }

  redirectPhysicalPaymentProgress() {
    this.router.navigateByUrl(this.locationService.base_url(`paymentProgress`));
  }

  getPaymentRoutingUrl() {
    const baseUrl = `${this.window.location.protocol}//${this.paymentData?.paymentFormParams?.storeAlias}.${environment.envDomain}`;
    const url = `${baseUrl}${this.window.location.pathname}${this.window.location.hash}`;
    return encodeURIComponent(url)
  }

  getPaymentRoutingThankYouUrl() {
    return encodeURIComponent(this.paymentData?.paymentFormParams?.successUrl);
  }

  onInitiateJccPayment() {
  }

  getPaymentDetails() {
    return {
      'backToCurrentCat': this.backToCurrentCat
    }
  }
  getCheckoutPaymentFormsComponent() {
    return this.checkoutPaymentFormsComponent;
  }


  ngOnInit(): void {
    super.onInit();
  }

}
